export default __webpack_public_path__ + "static/media/mission.d3efb552.jpg";